<template>
  <v-dialog v-model="dialog" persistent max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <v-layout justify-center>
        <v-btn text v-on="on" v-bind="attrs" rounded small class="mt-2"
          >Recuperar acesso</v-btn
        >
      </v-layout>
    </template>
    <v-card>
      <v-card-title>Recuperar acesso</v-card-title>
      <v-card-text class="subtitle-1">
        Entre em contato com a fábrica de rações para poder recuperar seu
        acesso.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" text rounded>OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
  }),
};
</script>

<style>
</style>